import clsx from 'clsx';

import { Modal } from '../../components';
import { JsonView } from '../../components';
import { formatDate, tryParseJSON } from '../../utilities';
import type { ItemType } from './useCampaignMonitoring';
import type { ContactStateType } from './useViewContactState';

type ViewStateModalProps = {
  isOpened: boolean;
  contact?: ItemType;
  state: ContactStateType[] | null;

  onClose: () => void;
};

type ContentProps = {
  state: ContactStateType[];
};

const prepareItem = (item: ContactStateType) => {
  return {
    state: item.state,
    state_details: tryParseJSON(item.state_details, true),
  };
};

const Content: React.FC<ContentProps> = ({ state }) => {
  if (!state.length) return <div>No items to display.</div>;

  return (
    <div className="flex flex-col">
      <div className="text-small mb-xl">
        Showing {state.length} state entries (most recent first)
      </div>
      <div className="flex flex-col gap-2xl">
        {state.map(item => {
          return (
            <div
              key={item.id}
              className={clsx(
                'flex flex-col gap-y-md',
                'pb-lg border-b border-active border-solid text-small text-textLight'
              )}
            >
              <div>
                <span className="font-semibold">Created: </span>
                {formatDate(item.created_at)}
              </div>
              <div>
                <span className="font-semibold">Workflow: </span>
                {item.workflow_id}
              </div>
              <JsonView value={prepareItem(item)} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

const ViewStateModal: React.FC<ViewStateModalProps> = ({
  isOpened,
  state,
  contact,
  ...rest
}) => {
  return (
    !!state &&
    !!contact && (
      <Modal open={isOpened} title="Contact State Details" {...rest}>
        <div className="text-medium mb-sm">
          Contact State History: {contact.contact_email}
        </div>
        <Content state={state} />
      </Modal>
    )
  );
};

export default ViewStateModal;
